import type { ClassScheduleEntry, GetMakeupResponse } from "@/openapi/generated";
import { makeupDateOnlyYmd } from "./makeupDates";
import {
  getScheduleEntryWallClock,
  normalizeMakeupTimeOnly,
  scheduleEntryEndTime,
  scheduleEntryStartTime,
  scheduleInstantYmd,
} from "./scheduleSlotDisplay";

/** True when a schedule entry matches the parent's requested makeup slot. */
export function makeupSlotMatchesRequest(
  entry: ClassScheduleEntry,
  item: GetMakeupResponse,
  timeZone?: string | null,
): boolean {
  if (!item.requestedDate || !item.requestedStartTime || !item.requestedEndTime) {
    return false;
  }

  const requestedYmd = makeupDateOnlyYmd(item.requestedDate, timeZone);
  if (!requestedYmd) return false;

  const wall = getScheduleEntryWallClock(entry);
  if (wall) {
    return (
      wall.dateYmd === requestedYmd &&
      normalizeMakeupTimeOnly(wall.startTime) ===
        normalizeMakeupTimeOnly(item.requestedStartTime) &&
      normalizeMakeupTimeOnly(wall.endTime) ===
        normalizeMakeupTimeOnly(item.requestedEndTime)
    );
  }

  const start = entry.start instanceof Date ? entry.start : new Date(entry.start);
  const end = entry.end instanceof Date ? entry.end : new Date(entry.end);
  if (Number.isNaN(start.getTime()) || Number.isNaN(end.getTime())) {
    return false;
  }

  const slotYmd = scheduleInstantYmd(start, timeZone);
  if (!slotYmd || requestedYmd !== slotYmd) {
    return false;
  }

  return (
    normalizeMakeupTimeOnly(scheduleEntryStartTime(entry, timeZone)) ===
      normalizeMakeupTimeOnly(item.requestedStartTime) &&
    normalizeMakeupTimeOnly(scheduleEntryEndTime(entry, timeZone)) ===
      normalizeMakeupTimeOnly(item.requestedEndTime)
  );
}
